import React from 'react';
import { Button } from 'react-bootstrap';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

function goBack() {
    window.history.back()
}

export default function BtnVoltar(props) {
    return (
        <Button onClick={() => goBack()}>
            <ArrowBackIcon />
             Voltar
        </Button>
    )
};